import React from 'react';
import classNames from 'classnames';
import { RadioButtonProvider } from './RadioButtonContext';
import styles from './RadioButtonGroup.module.css';

function RadioButtonGroup({ value, onChange, className, children, ...rest }) {
  return (
    <RadioButtonProvider radioButton={{ value, onChange }}>
      <div className={classNames(styles.root, className)} {...rest}>
        {children}
      </div>
    </RadioButtonProvider>
  );
}

export default RadioButtonGroup;
